'use strict';

const tealium = {
  eventCount: 0,

  updateData: function (arr) {
    const { utag_data } = window;
    const { search_mode, search_engine, fbb_search_enabled } = utag_data || {};
    const updatedArr = { ...arr, search_mode, search_engine, fbb_search_enabled };
    if (window.utag_data_backup) {
      window.utag_data = window.utag_data_backup;
    }else{
      window.utag_data_backup = window.utag_data;
    }
    window.utag_data = { ...window.utag_data, ...arr };
    return { updatedArr:updatedArr, isAdobeAnalytics:true };
  },

  triggerEvent: function (arr) {
    const { utag, adobeDataLayer } = window;
    const { updatedArr, isAdobeAnalytics } = this.updateData(arr);
    if(window.utag_data && window.utag_data.page_name && window.utag_data.page_name.toLowerCase() === 'confirmation' &&
                           window.utag_data.page_type && window.utag_data.page_type.toLowerCase() === 'confirmation' &&
                           window.utag_data.rendered_page && window.utag_data.rendered_page !== 'orderconfirmation') {
      window.utag_date.page_name = 'maybeorderdetails';
      window.utag_data.page_type = 'maybeorderdetails';
    }
    if (isAdobeAnalytics) {
      try {
        adobeDataLayer.push(window.utag_data);
      } catch (e) {
        console.log(e.message ?  e.message : e);
      }
    } else {
      utag.link(updatedArr);
    }
    if (isAdobeAnalytics) {
      console.log('Tealium event triggered', window.utag_data);
    }else {
      console.log('Tealium event triggered', updatedArr);
    }
    return updatedArr;
  },
  triggerViewEvent: function (arr) {
    const { utag, adobeDataLayer } = window;
    const { updatedArr, isAdobeAnalytics } = this.updateData(arr);
    if (isAdobeAnalytics) {
      try {
        adobeDataLayer.push(window.utag_data);
      } catch (e) {
        console.log(e.message ?  e.message : e);
      }
    }else{
      utag.view(updatedArr);
    }
    if (isAdobeAnalytics) {
      console.log('Tealium event triggered', window.utag_data);
    }else {
      console.log('Tealium event triggered', updatedArr);
    }
    return updatedArr;
  }
};

module.exports = tealium;
